import React from 'react';

interface ITooltip {
  label: string;
  children?: React.ReactNode;
}

export const Tooltip = (props: ITooltip) => {
  const { label, children } = props;
  return (
    <div className='relative group inline-block'>
      { /* Truncated Text */ }
      <div className='max-w-[180px] truncate whitespace-nowrap overflow-hidden'>
        { children || label || '-' }
      </div>

      { /* Tooltip */ }
      <div className='absolute z-[9999] hidden group-hover:flex flex-col items-center'>
        <div className='relative'>
          { /* Tooltip Box */ }
          <div className='absolute top-[-100%] mb-2 px-3 py-2 text-sm text-white bg-gray-900 rounded-md shadow-lg w-max max-w-xs whitespace-normal'>
            { label }
          </div>
        </div>
      </div>
    </div>
  );
};
